export class InsightColors {

    public static gray100 = "#f8f9fa";
    public static gray200 = "#e9ecef";
    public static gray300 = "#dee2e6";
    public static gray400 = "#ced4da";
    public static gray500 = "#adb5bd";
    public static gray600 = "#868e96";
    public static gray700 = "#495057";
    public static gray800 = "#343a40";
    public static gray900 = "#212529";
    public static black = "#000";

    public static blue = "#007bff";
    public static indigo = "#6610f2";
    public static purple = "#6f42c1";
    public static pink = "#e83e8c";
    public static red = "#e10019";
    public static orange = "#fd7e14";
    public static yellow = "#e1dc00";
    public static green = "#19a546";
    public static teal = "#20c997";
    public static cyan = "#0078be";
    public static lime = "#becd00";

    public static primary = "#0af";
    public static secondary = "#6c7a77";
    public static success = "#19a546";
    public static info = "#0078be";
    public static warning = "#e1dc00";
    public static danger = "#e10019";
    public static light = "#f0f1f1";
    public static dark = "#333";

    public static colorsArray: string[] = [
        InsightColors.blue,
        InsightColors.lime,
        InsightColors.indigo,
        InsightColors.green,
        InsightColors.teal,
        InsightColors.red
    ]

}